import { Collapse } from '@mui/material';
import React, { useState } from 'react';

import LoginForm from '@/features/identity/components/LoginForm';
import ResetPasswordForm from '@/features/identity/components/ResetPasswordForm';

const EmailLoginDialog: React.FC = () => {
  const [isForgottenPW, setIsForgottenPW] = useState<boolean>(false);
  return (
    <>
      <Collapse in={!isForgottenPW}>
        <LoginForm handleForgotPWClick={setIsForgottenPW} />
      </Collapse>
      <Collapse in={isForgottenPW}>
        <ResetPasswordForm handleForgotPWClick={setIsForgottenPW} />
      </Collapse>
    </>
  );
};

export default EmailLoginDialog;
